
import { metaDataMixin, hoursMixin } from '~/mixins'

export default {
  mixins: [
    metaDataMixin,
    hoursMixin,
  ],
  layout: 'careers',
  async asyncData ({ $api, $config, $log, store, route }) {
    const [
      { data: { items: internships = [] } = {}, statusTextInternships },
      { data: { item: recruiter = {} } = {} },
    ] = await Promise.all([
      // Get internships
      await $api.recruitment.getAllVacancies({
        department: $config.careers.internships.department,
      }),
      // Get recruiter for internships
      await $api.persons.getOne($config.careers.internships.recruiterId),
    ])

    if (!internships) {
      $log.warn({ statusTextInternships })
    }

    // Set breadcrumbs for the page
    store.dispatch('breadcrumbs/mirror', {
      path: route.path,
      mirror: `/werken-bij`,
    })

    return {
      internships,
      recruiter,
    }
  },
  data () {
    return {
      hero: 'https://1jcwt93ssvbz.b-cdn.net/{format}/s3-corporate-eo/18027e99-79b1-4606-91fe-f03554bba04e.jpg',
      internships: null,
      recruiter: null,
      seo: {
        title: 'Stages',
        description: 'Op zoek naar een goede stage? De EO heeft er een heleboel in de aanbieding! Bekijk ze hier allemaal en solliciteer online naar een leuke en leerzame stage.',
      },
    }
  },
}
